import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=56a4c927"
import script from "./ContactForm.vue?vue&type=script&lang=ts"
export * from "./ContactForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports